module.exports = __webpack_public_path__ + "img/golia-truck.ff56cd5b.png";